import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Paper from "@mui/material/Paper";

const styles = {
  dialogContent: {
    bgcolor: "#f4f6f8",
    p: 4,
  },
  closeButton: {
    position: "absolute",
    right: 16,
    top: 16,
  },
  titleBox: {
    textAlign: "center",
    mb: 4,
  },
  cardsContainer: {
    display: "flex",
    gap: 3,
    mb: 4,
  },
  card: (selected) => ({
    flex: 1,
    bgcolor: "white",
    px: 2,
    py: 3,
    borderRadius: 2,
    cursor: "pointer",
    border: selected ? "3px solid" : "2px solid",
    borderColor: selected ? "primary.main" : "grey.300",
    transition: "all 0.2s",
    "&:hover": {
      borderColor: selected ? "primary.main" : "grey.400",
      boxShadow: selected ? 4 : 2,
    },
    boxShadow: selected ? 3 : 0,
  }),
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2,
  },
  bulletList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  bulletItem: {
    display: "flex",
    alignItems: "flex-start",
    mb: 1.5,
    "&:last-child": {
      mb: 0,
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
};

export default function BillingSetupQuestionModal({ open, onClose, onSelectSame, onSelectDifferent }) {
  const [selected, setSelected] = useState(null);

  const handleContinue = () => {
    if (selected === 'same') {
      onSelectSame();
    } else if (selected === 'different') {
      onSelectDifferent();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: { width: "870px", maxWidth: "90vw" }
      }}
    >
      <IconButton onClick={onClose} sx={styles.closeButton}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.dialogContent}>
        <Box sx={styles.titleBox}>
          <Typography fontSize={22} fontWeight={500} color="textPrimary">
            How should services be billed?
          </Typography>
        </Box>

        <Box sx={styles.cardsContainer}>
          <Paper
            elevation={0}
            sx={styles.card(selected === 'different')}
            onClick={() => setSelected('different')}
          >
            <Box sx={styles.cardHeader}>
              <Typography fontSize={18} fontWeight={500} color="textPrimary">
                Mix of Billing Types
              </Typography>
            </Box>
            <Typography fontSize={14} fontWeight={500} color="textPrimary" mb={1.5}>
              Choose this if:
            </Typography>
            <Box component="ul" sx={styles.bulletList}>
              <Box component="li" sx={styles.bulletItem}>
                <Typography fontSize={14} color="text.secondary" mr={0.5}>•</Typography>
                <Typography fontSize={14} color="text.secondary">
                  Billing differs for Inbound, Outbound, and Storage
                </Typography>
              </Box>
              <Box component="li" sx={styles.bulletItem}>
                <Typography fontSize={14} color="text.secondary" mr={0.5}>•</Typography>
                <Typography fontSize={14} color="text.secondary">
                  Example: Inbound and Outbound are billed by the pallet while Storage is billed by the square foot
                </Typography>
              </Box>
            </Box>
          </Paper>

          <Paper
            elevation={0}
            sx={styles.card(selected === 'same')}
            onClick={() => setSelected('same')}
          >
            <Box sx={styles.cardHeader}>
              <Typography fontSize={18} fontWeight={500} color="textPrimary">
                Same Billing Type
              </Typography>
            </Box>
            <Typography fontSize={14} fontWeight={500} color="textPrimary" mb={1.5}>
              Choose this if:
            </Typography>
            <Box component="ul" sx={styles.bulletList}>
              <Box component="li" sx={styles.bulletItem}>
                <Typography fontSize={14} color="text.secondary" mr={0.5}>•</Typography>
                <Typography fontSize={14} color="text.secondary">
                  Billing is the same for Inbound, Outbound, and Storage
                </Typography>
              </Box>
              <Box component="li" sx={styles.bulletItem}>
                <Typography fontSize={14} color="text.secondary" mr={0.5}>•</Typography>
                <Typography fontSize={14} color="text.secondary">
                  Example: Inbound, Outbound, and Storage are all billed by the pallet
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>

        <Box sx={styles.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleContinue}
            disabled={!selected}
            sx={{ px: 4, py: 1, fontSize: 14, textTransform: "none" }}
          >
            Continue
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
